import {Component, ChangeDetectionStrategy, Input, EventEmitter, Output, OnInit} from "@angular/core";
import {LogCat, LogManager} from "../../../log";
import {FavoritesTooltipsKeys} from "./favorites-tooltips-keys.interface";

//import {LogManager, LogCat} from "../../../../../common/log";

@Component({
	selector: 'cp-favorite-button',
	templateUrl: './cp-favorite-button.template.html',
	styleUrls: ['./cp-favorite-button.style.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FavoriteButtonComponent implements OnInit {

	@Input() key: any; //a unique identifier value //number;
	@Input() disabled: boolean = false;
	@Input() isFavorite: boolean = false;//Is the button in item chosen as a favorite state
	@Input() isMaxFavoritesNumber: boolean = false;
	@Output() onClick = new EventEmitter<FavoriteEvent>();


	public dictionary: FavoritesTooltipsKeys | {} = {};

	constructor() {
		LogManager.debug(LogCat.UI.FavoriteButton, "FavoriteButtonComponent.constructor");
	}

	ngOnInit() {
		LogManager.debug(LogCat.UI.FavoriteButton, "FavoriteButtonComponent.ngOnInit");
		this.initDictionary();
	}

	/* ***************************************************************************
	* Public Methods
	* ************************************************************************** */

	public clickHandler() {
		LogManager.debug(LogCat.UI.FavoriteButton, "FavoriteButtonComponent.clickHandler");
		if (!this.disabled && (this.isFavorite || (!this.isFavorite && !this.isMaxFavoritesNumber))) {
			this.onClick.emit({key: this.key, isFavorite: !this.isFavorite});
		}
	}

	/* ***************************************************************************
	* Private Methods
	* ************************************************************************** */

	/*
	* Initialize dictionary labels
	* */
	private initDictionary() {
		LogManager.debug(LogCat.UI.FavoriteButton, "FavoriteButtonComponent.initDictionary");
		this.dictionary = {
			addToFavorites: 'AddToFavorites',
			removeFromFavorites: 'RemoveFromFavorites',
			maxFavoritesReached: 'MaxFavoriteWorklistsHasBeenSelected'
		};
	}


}

export type FavoriteEvent = { key: any; isFavorite: boolean; };
